import React from 'react';

/**
 * TimeSelect component - A select dropdown for choosing times in 24-hour format
 * with 30-minute increments (00:00, 00:30, 01:00, ... 23:30)
 */
function TimeSelect({ id, value, onChange, required = false }) {
  // Generate time options in 30-minute increments
  const generateTimeOptions = () => {
    const options = [];

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const hourStr = hour.toString().padStart(2, '0');
        const minuteStr = minute.toString().padStart(2, '0');
        const timeValue = `${hourStr}:${minuteStr}`;
        options.push(timeValue);
      }
    }

    return options;
  };

  const timeOptions = generateTimeOptions();

  return (
    <select
      id={id}
      value={value}
      onChange={onChange}
      required={required}
    >
      <option value="">Velg tid</option>
      {timeOptions.map(time => (
        <option key={time} value={time}>
          {time}
        </option>
      ))}
    </select>
  );
}

export default TimeSelect;
